
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.697 13.4v5.1h1.96c.293.004.56.156.714.401l.052.096a.842.842 0 01-.131.907l-5.515 6.422a.5.5 0 01-.88-.326v-5.1H17.96a.855.855 0 01-.735-.399l-.054-.098a.842.842 0 01.132-.907l5.515-6.422a.5.5 0 01.88.326zM8.56 19.46c1.495 2.869 4.513 4.612 8.338 4.612a.5.5 0 110 1c-4.19 0-7.554-1.943-9.225-5.15a.5.5 0 11.887-.462zm14.137-4.712L18.272 19.9h2.126a.5.5 0 01.491.41l.009.09-.001 4.251L25.32 19.5h-2.124a.5.5 0 01-.492-.41l-.008-.09v-4.252zM10.599 14.3a.5.5 0 01.5.5v1.4a.5.5 0 11-1 0v-1.4a.5.5 0 01.5-.5zm3.321-1.086l.99.99a.5.5 0 01-.708.707l-.989-.99a.5.5 0 01.707-.707zm-5.935 0a.5.5 0 010 .708l-.989.989a.5.5 0 01-.707-.707l.989-.99a.5.5 0 01.707 0zM10.6 8a2.6 2.6 0 110 5.2 2.6 2.6 0 010-5.2zm0 1a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm5.6 1.1a.5.5 0 110 1h-1.4a.5.5 0 010-1h1.4zm-9.8 0a.5.5 0 010 1H5a.5.5 0 010-1h1.4zm11.185-4.097l.09.005a9.617 9.617 0 016.644 4.322.5.5 0 01-.842.54 8.617 8.617 0 00-5.954-3.873.5.5 0 01.062-.994zm-10.588.286l.99.99a.5.5 0 11-.708.707l-.99-.99a.5.5 0 01.708-.707zm7.913 0a.5.5 0 010 .707l-.989.99a.5.5 0 11-.707-.708l.99-.989a.5.5 0 01.706 0zM10.6 4.5a.5.5 0 01.5.5v1.4a.5.5 0 11-1 0V5a.5.5 0 01.5-.5z","fill":"#12181D","fill-rule":"nonzero"}})])
          )
        }
      }
    